import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=d2faaa38&scoped=true&"
import script from "./EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=d2faaa38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2faaa38",
  null
  
)

export default component.exports